module.exports = __webpack_public_path__ + "img/45.ca8e0f7d.jpg";